export default __webpack_public_path__ + "static/DSC_0445-437f375a2608bf53ce79f85f3f480312.jpg";